var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPet = function SvgPet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M6.615 25.125C6.255 29.46 9.525 33 13.875 33h7.185c4.89 0 8.25-3.945 7.44-8.775C27.645 19.155 22.755 15 17.61 15c-5.58 0-10.53 4.56-10.995 10.125M15.705 11.25a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5M25.95 13.05a3 3 0 1 0 0-6 3 3 0 0 0 0 6M31.5 19.05a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5M5.955 16.05a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
  })));
};
export default SvgPet;